export default "__VITE_ASSET__BiaNgfUg__"